

































































import Vue from 'vue';
import TheFlashcard from '@/components/TheFlashcard.vue';
import { BDropdown, BDropdownItem } from 'bootstrap-vue';
import { Card, Deck } from '@/types';
export default Vue.extend({
  components: { flashcard: TheFlashcard, BDropdown, BDropdownItem },
  props: {
    deck: {
      type: Object as () => Deck, // https://frontendsociety.com/using-a-typescript-interfaces-and-types-as-a-prop-type-in-vuejs-508ab3f83480
      default() {
        return {
          cards: [] as Card[],
          title: 'Default Deck',
          _id: '',
          deleted: true,
          ttl: 1596161096048,
        };
      },
    },
  },
  computed: {
    cards() {
      return this.deck.cards.filter(card => !card.deleted);
    },
  },
});
